import React from "react";
import { getCaseLink, getProductNameBy } from "@/src/services/productService";
import useProductParams from "@/src/hooks/useProductParams";
import FeedbackConfirmationPage from "@/src/components/Serviceworld/Feedback/FeedbackConfirmationPage";

export default function InquiryToCustomerAnsweredPage() {
  const { productName, productId } = useProductParams();

  return <FeedbackConfirmationPage caseLink={getCaseLink({ name: getProductNameBy("urlPartShort", productName), id: productId })} />;
}
